import Icon from "./Icon";
import { reopenInExternalBrowser } from "../utils/documentDownload";

interface ExternalBrowserNoticeProps {
  // "external": inside LINE, which can reopen this page in the system browser.
  // "manual": another in-app browser, where only the user can switch.
  method: "external" | "manual";
  hint?: string;
}

const ExternalBrowserNotice = ({ method, hint }: ExternalBrowserNoticeProps) => (
  <div style={{ width: "100%", maxWidth: "320px", display: "flex", flexDirection: "column", gap: "12px" }}>
    {method === "external" ? (
      <button
        onClick={reopenInExternalBrowser}
        style={{
          width: "100%",
          border: "none",
          borderRadius: "8px",
          padding: "12px 20px",
          background: "#4263B5",
          color: "#FFFFFF",
          fontSize: "14px",
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
        }}
      >
        <Icon icon="arrow-up-right-from-square" style={{ fontSize: "14px" }} />
        <span>เปิดในเบราว์เซอร์เพื่อบันทึก</span>
      </button>
    ) : null}

    <div style={{ color: "#6F6B7D", fontSize: "13px" }}>
      {method === "external"
        ? "LINE บันทึกไฟล์ลงเครื่องไม่ได้ หากกดแล้วไม่เปิด ให้แตะเมนูของ LINE มุมขวาบน แล้วเลือกเปิดด้วยเบราว์เซอร์"
        : "เบราว์เซอร์ในแอปนี้บันทึกไฟล์ไม่ได้ กรุณาแตะเมนูมุมขวาบน แล้วเลือกเปิดใน Safari หรือ Chrome"}
      {hint ? <div style={{ marginTop: "8px" }}>{hint}</div> : null}
    </div>
  </div>
);

export default ExternalBrowserNotice;
